export const chickenMeatData = [
    {
        performanceProgress: 'ปริมาณขาย',
        quantity: 'ตัน',
        January: '35,547',
        February: '31,996',
        March: '39,470',
        April: '46,259',
        May: '46,340',
        June: '46,650',
        July: '48,352',
        August: '49,426',
        September: '44,075',
        October: '46,198',
        November: '45,792',
        December: '46,305',
        total: '526,412',
    },
    {
        performanceProgress: 'มูลค่าขาย',
        quantity: 'ล้านบาท',
        January: '536',
        February: '478',
        March: '611',
        April: '730',
        May: '746',
        June: '769',
        July: '807',
        August: '846',
        September: '768',
        October: '804',
        November: '803',
        December: '810',
        total: '8,708',
    },
    {
        performanceProgress: 'ราคาขาย',
        quantity: 'บาท/ก.ก.',
        January: '15.1',
        February: '14.9',
        March: '15.5',
        April: '15.8',
        May: '16.1',
        June: '16.5',
        July: '16.7',
        August: '17.1',
        September: '17.4',
        October: '17.4',
        November: '17.5',
        December: '17.5',
        total: '16.5',
    },
    {
        performanceProgress: 'ต้นทุนรวม',
        quantity: 'บาท/ก.ก.',
        January: '(15.0)',
        February: '(15.3)',
        March: '(15.8)',
        April: '(15.9)',
        May: '(16.1)',
        June: '(16.6)',
        July: '(17.4)',
        August: '(17.5)',
        September: '(17.4)',
        October: '(17.3)',
        November: '(17.3)',
        December: '(17.4)',
        total: '(16.7)',
    },
    {
        performanceProgress: 'กำไรสุทธิ',
        quantity: 'บาท/ก.ก.',
        January: '0.1',
        February: '0.4',
        March: '0.4',
        April: '0.1',
        May: '0.0',
        June: '0.1',
        July: '0.7',
        August: '0.4',
        September: '0.0',
        October: '0.1',
        November: '0.2',
        December: '0.0',
        total: '0.1',
    },
    {
        performanceProgress: '',
        quantity: 'ล้านบาท',
        January: '5',
        February: '(11)',
        March: '(14)',
        April: '(4)',
        May: '(0)',
        June: '(7)',
        July: '(32)',
        August: '(19)',
        September: '2',
        October: '4',
        November: '10',
        December: '2',
        total: '(65)',
    },
    {
        performanceProgress: '',
        quantity: '%',
        January: '0.9%',
        February: '(2.4)%',
        March: '(2.3)%',
        April: '(0.6)%',
        May: '(0.0)%',
        June: '(0.9)%',
        July: '(4.0)%',
        August: '(2.2)%',
        September: '0.2%',
        October: '0.5%',
        November: '1.3%',
        December: '0.2%',
        total: '(0.7)%',
    },
]